import routesFactory from './routes/routes'
import { MODULE_NAME } from './store/types'
import showcaseAutomationModule from './store/module'

export const DOMAIN_NAME = 'SHOWCASE'

export const domainConfig = () => {
  return {
    router: { routesFactory },
    vuex: [
      {
        name: MODULE_NAME,
        moduleFactory: showcaseAutomationModule
      }
    ],
    apollo: {
      name: DOMAIN_NAME,
      config: {
        url:
          'https://lfrs5577cbcnpeamrwczodpp44.appsync-api.eu-west-1.amazonaws.com/graphql'
      }
    }
  }
}
